import React from 'react'
export default function CrossIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 19">
            <path fillRule="evenodd" d="M9.4 0c.5 0 1 .4 1 1v7h7.2a1 1 0 1 1 0 2h-7.2v7.5a1 1 0 1 1-2 0V10H1a1 1 0 1 1 0-2h7.3V1c0-.6.4-1 1-1Z" clipRule="evenodd"/>
        </svg>
    )
}


